/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Column visible properties of the given property in case of table
 * @export
 * @interface ColumnViewSettings
 */
export interface ColumnViewSettings {
    /**
     * 
     * @type {string}
     * @memberof ColumnViewSettings
     */
    afterColumn?: string;
    /**
     * 
     * @type {number}
     * @memberof ColumnViewSettings
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof ColumnViewSettings
     */
    propertyName: string;
    /**
     * 
     * @type {number}
     * @memberof ColumnViewSettings
     */
    width?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ColumnViewSettings
     */
    pinned?: boolean;
}

/**
 * Check if a given object implements the ColumnViewSettings interface.
 */
export function instanceOfColumnViewSettings(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "propertyName" in value;

    return isInstance;
}

export function ColumnViewSettingsFromJSON(json: any): ColumnViewSettings {
    return ColumnViewSettingsFromJSONTyped(json, false);
}

export function ColumnViewSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ColumnViewSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'afterColumn': !exists(json, 'afterColumn') ? undefined : json['afterColumn'],
        'position': !exists(json, 'position') ? undefined : json['position'],
        'propertyName': json['propertyName'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'pinned': !exists(json, 'pinned') ? undefined : json['pinned'],
    };
}

export function ColumnViewSettingsToJSON(value?: ColumnViewSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'afterColumn': value.afterColumn,
        'position': value.position,
        'propertyName': value.propertyName,
        'width': value.width,
        'pinned': value.pinned,
    };
}

